import { render, staticRenderFns } from "./ServerEditor.vue?vue&type=template&id=5d405c1a&scoped=true&"
import script from "./ServerEditor.vue?vue&type=script&lang=js&"
export * from "./ServerEditor.vue?vue&type=script&lang=js&"
import style0 from "./ServerEditor.vue?vue&type=style&index=0&id=5d405c1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d405c1a",
  null
  
)

export default component.exports